import Icon from '@forwardflow/ui/Icons'
import React, { useState } from 'react'

interface PhoneNumberItemProps {
   number: string
   place: string
   isAdded: boolean
   hideActionButton?: boolean
   isUnavailable?: boolean
   onRemoveCampaignPhoneNumber?: () => void
   onAddCampaignPhoneNumber?: () => void
}

export const PhoneNumberItem: React.FC<PhoneNumberItemProps> = ({
   number,
   place,
   isAdded,
   hideActionButton = false,
   isUnavailable = false,
   onRemoveCampaignPhoneNumber,
   onAddCampaignPhoneNumber,
}) => {
   const [isSelected, setSelected] = useState(true)

   return isUnavailable ? (
      <div
         className={`flex items-center h-[62px] pl-10 pr-6 bg-error/20 hover:bg-error/40 gap-x-6 hover:primary/20 overflow-hidden group cursor-pointer`}
      >
         <div className="flex flex-col gap-y-1">
            <p className="font-medium">{number}</p>
            <p className="text-[14px] text-white/70 font-bold">{place}</p>
         </div>
         <div className="flex mr-2 w-[full] items-center ml-auto font-medium">
            <button
               onClick={() => {
                  onRemoveCampaignPhoneNumber?.()
               }}
               className="h-10 ml-2 px-3 group-hover:block transition-all content-end border rounded w-28 border-[#C11574] bg-[#C11574]/20 hover:bg-[#C11574]/40"
            >
               Remove
            </button>
         </div>
      </div>
   ) : (
      <div
         className={`flex items-center h-[62px] px-10 bg-primary/10 hover:bg-primary/20 gap-x-6 hover:primary/20 overflow-hidden group cursor-pointer`}
      >
         <div className="flex flex-col gap-y-1">
            <p className="font-medium">{number}</p>
            <p className="text-[12px] text-white/70">{place}</p>
         </div>
         {hideActionButton && (
            <div className="flex items-center ml-auto font-medium ">
               {isAdded ? (
                  <button
                     onClick={onRemoveCampaignPhoneNumber}
                     className="h-10 ml-2 group-hover:block hidden transition-all border rounded w-28 border-[#C11574] bg-[#C11574]/20 hover:bg-[#C11574]/40"
                  >
                     Remove
                  </button>
               ) : (
                  <div className="w-24 flexc">
                     {isSelected ? (
                        <button
                           onClick={() => {
                              onAddCampaignPhoneNumber?.()
                              setSelected(false)
                           }}
                           className="hidden w-24 h-10 transition-all border rounded group-hover:block border-primary bg-primary/20 hover:bg-primary"
                        >
                           Add
                        </button>
                     ) : (
                        <>
                           <div className="w-6 h-6 rounded-full flexc bg-primary group-hover:hidden">
                              <Icon
                                 name="Check"
                                 className="fill-white"
                                 width={12}
                                 height={12}
                              />
                           </div>
                           <button
                              onClick={() => {
                                 onRemoveCampaignPhoneNumber?.()
                                 setSelected(true)
                              }}
                              className="h-10 ml-2 group-hover:block hidden shrink-0 transition-all border rounded w-28 border-[#C11574] bg-[#C11574]/20 hover:bg-[#C11574]/40"
                           >
                              Remove
                           </button>
                        </>
                     )}
                  </div>
               )}
            </div>
         )}
      </div>
   )
}
